import { Component, OnInit } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { NzModalRef } from 'ng-zorro-antd';
import { apiPrefix } from '../../utils/constants';
import { URLS } from '../../constant/interface';

@Component({
  selector: 'app-media-select',
  templateUrl: './icc-media-select.component.html',
  styleUrls: ['./icc-media-select.component.less'],
})
export class IccMediaSelectComponent implements OnInit {
  mediaType: 'img' | 'video' | 'audio';
  channelIds: number[];
  constructor(public http: _HttpClient, private modal: NzModalRef) {}
  name: null;
  title: null;
  audioName: null;
  mediaList = [];
  currentIndex = 1;
  pageSize = 10;
  total = 0;
  selectedMedia = null;
  mediaUrl = apiPrefix + '/common/downloadMaterial/';

  downloadUrl = URLS.attachment.url;

  isLoading = true;

  // 分组url
  groupUrl = '/groupData';    // 测试用
  // 分组数据
  groupData = [];
  // 分组默认选中项
  defaultSelectedKeys;

  ngOnInit() {
    this.queryMediaList();
  }

  queryMediaList() {
    let mType = 0;
    if (this.mediaType === 'img') {
      mType = 0;
    } else if (this.mediaType === 'video') {
      mType = 1;
    } else if (this.mediaType === 'audio') {
      mType = 2;
    }
    console.log('channelIds: ', this.channelIds);
    this.getGroups();
    let page = {
      pi: this.currentIndex,
      ps: this.pageSize,
      params: {
        title: this.title || this.name || this.audioName,
        type: mType,
        noState: 2,
        state: 4,
        ids: this.channelIds,
      },
    };
    this.http.post(apiPrefix + '/common/mediaList', page).subscribe(data => {
      this.isLoading = false;
      this.mediaList = data.list;
      if (this.mediaList) {
        this.mediaList.forEach(m => {
          m.selectState = 0;
          if (m.state === 0) {
            m.selectState = 2;
          }
          m.allName = m.name;
          if (m.name && m.name.length > 10) {
            m.name = m.name.substring(0, 10) + '...';
          }
        });
      }
      this.total = data.total;
    });
  }

  getGroups() {
    this.http.get(this.groupUrl).subscribe(data => {
      let groupData = [];
      data.forEach(item => {
        groupData.push({
          key: String(item.channelId),
          id: item.channelId,
          title: item.name,
          isLeaf: true
        })
      })
      this.groupData = groupData;
      this.defaultSelectedKeys = [this.groupData[0].key];
      console.log('groupData: ', this.groupData);
    })
  }

  stateChange(selectState, media) {
    this.mediaList
      .filter(m => m !== media && m.selectState !== 2)
      .forEach(m => {
        m.selectState = 0;
      });
    media.selectState = 1;
    this.mediaList = this.mediaList;
    if (selectState) {
      this.selectedMedia = media;
    } else {
      this.selectedMedia = null;
    }
  }
  search() {
    this.queryMediaList();
  }

  destroy() {
    this.modal.triggerCancel();
  }

  confirm() {
    this.modal.close(this.selectedMedia);
  }

  pageChange(i) {
    this.currentIndex = i;
    this.queryMediaList();
  }

  // 分组点击事件
  nzClick() {
    console.log('点击了分组！');
  }
}
